import React from 'react';
import BackButton from './BackButton';

function LoginPage({ setPage, handleLogin }) {
  return (
    <div style={{ minHeight: '100vh', background: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ maxWidth: '400px', width: '100%', padding: '32px', border: '1px solid #e0e0e0', borderRadius: '8px' }}>
        <img
          src="/logo.svg"
          alt="PatTrak Logo"
          style={{
            height: '48px',
            display: 'block',
            margin: '0 auto 24px auto',
            cursor: 'pointer'
          }}
          onClick={() => setPage('search')}
        />
        <h1 style={{ fontSize: '28px', fontWeight: 'bold', color: '#1d2934', marginBottom: '24px', textAlign: 'center' }}>
          Log In
        </h1>
        <form onSubmit={handleLogin}>
          <input
            type="email"
            name="email"
            placeholder="Email"
            required
            style={{ width: '100%', padding: '12px', marginBottom: '16px', border: '1px solid #5e778a', borderRadius: '4px', fontSize: '16px' }}
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            required
            style={{ width: '100%', padding: '12px', marginBottom: '24px', border: '1px solid #5e778a', borderRadius: '4px', fontSize: '16px' }}
          />
          <button
            type="submit"
            style={{ width: '100%', background: '#53dafc', color: 'white', padding: '12px', borderRadius: '4px', border: 'none', fontSize: '16px', fontWeight: '600', cursor: 'pointer', marginBottom: '16px' }}
          >
            Log In
          </button>
        </form>
        <p style={{ textAlign: 'center', color: '#5e778a' }}>
          Don't have an account?{' '}
          <button onClick={() => setPage('register')} style={{ background: 'none', border: 'none', color: '#53dafc', cursor: 'pointer', textDecoration: 'underline' }}>
            Sign up
          </button>
        </p>
        <BackButton onClick={() => setPage('search')} variant="auth" />
      </div>
    </div>
  );
}

export default LoginPage;
